/**
 * Pre-compiled pt-BR messages for RangeCalendar
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  nextMonth: `Próximo mês`,
  nextYear: `Próximo ano`,
  previousMonth: `Mês anterior`,
  previousYear: `Ano anterior`,
};
